export default "__VITE_PUBLIC_ASSET__4511eb53__"